"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.st = exports.t = exports.s = exports.r = exports.q = exports.pq = exports.p = void 0;
var p = { w: 0.03, h: 8, i: 0.05 }, pq = { w: 0.1, h: 0 }, q = { w: 0.005, h: -10 }, r = { w: 0.011, h: 50, i: 0.02 }, s = { w: 0.005, h: -20, i: 0.02 }, st = { w: 0.20, h: 0 }, t = { w: 0.050, h: 10 };
exports.p = p;
exports.pq = pq;
exports.q = q;
exports.r = r;
exports.s = s;
exports.st = st;
exports.t = t;
